import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map } from 'rxjs/operators';
import { ApolloInstances } from '../api';
import GET_OFFERS_PERMISSIONS from '../api/graphql/offer/queries/get-offers-permissions';
import { RfpAndOffersPermissionResult } from '../types/permissions/rfp-and-offers-permission-result';


@Injectable({
  providedIn: 'root',
})
export class OffersPermissionsService {
  constructor(private apollo: Apollo) {}
  getOffersPermissions(rfpId: number) {
    return this.apollo
      .use(ApolloInstances.OFFER)
      .query<{ offerPermissions: RfpAndOffersPermissionResult[] }>({
        variables: { rfpId },
        query: GET_OFFERS_PERMISSIONS,
      })
      .pipe(map((request) => request.data.offerPermissions));
  }
}
